// Module
var code = "<div class=\"ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle u-flexSpaced\" ng-bind-html=\"row.entity.serviceName | invEmpty\" smart-truncate></div>\n</div>\n";
// Exports
module.exports = code;